<template>
  <div>
    <div class="user-activity-wrapper">
      <div class="user-activity-content">
        <template v-if="isActivityGoalEnabled">
          <h2 class="user-activity-title mt-6 mb-4">
            {{ $t('UserActivity.pageTitle.label') }}
          </h2>
          <div v-if="firstBlockTabs.length > 1" class="tabs-wrapper mb-3">
            <v-tabs
              v-model="activeFirstBlockTab.id"
              slider-size="4"
              class="activity-tabs"
            >
              <v-tab
                v-for="(tab, index) in firstBlockTabs"
                :key="index"
                exact
                nuxt
                :to="tab.to"
                class="text-none px-0"
              >
                {{ tab.label }}
              </v-tab>
            </v-tabs>
          </div>
        </template>
        <slot />
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppStateEnum from '@/enums/AppStateEnum';
import ManagePublicationsStates from '@/enums/ManagePublicationsStatesEnum';
import AppFooter from '@/components/views/AppFooter/AppFooter';

export default {
  name: 'UserActivity',
  components: {
    AppFooter
  },
  data() {
    const firstBlockTabs = [
      {
        id: 0,
        to: { name: AppStateEnum.ACTIVITY_DASHBOARD },
        label: this.$t('UserActivity.MyActivity.label')
      }
      // TODO: uncomment when start development of reading group
      // {
      //   id: 1,
      //   to: { name: AppStateEnum.READING_GROUP },
      //   label: this.$t('UserActivity.ReadingGroup.label')
      // }
    ];

    return {
      firstBlockTabs,
      currentFirstBlockTab: null
    };
  },
  computed: {
    ...mapGetters('ContextStore', ['isActivityGoalEnabled']),
    ...mapGetters('UserStore', ['isGuestUser']),
    activeFirstBlockTab: {
      get() {
        return this.currentFirstBlockTab || this.firstBlockTabs[0];
      },
      set(tab) {
        this.currentFirstBlockTab = tab;
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('LibraryStore/initState', {
      managePublicationsState: ManagePublicationsStates.LIBRARY
    });
    if (this.isGuestUser) {
      await this.$store.dispatch('ActivityStore/fillUserActivity');
    }
  },
  methods: {
    selectFirstBlockActiveTab(tab) {
      this.activeFirstBlockTab = tab;
    }
  }
};
</script>

<style lang="less" src="./UserActivity.less"></style>
